import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-no-access',
    templateUrl: './no-access.component.html',
    styleUrls: ['./no-access.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NoAccessComponent {
    readonly portalUrl = 'https://engtoolapp.engineeringhub.dev.gea.com/';
}
